import React from "react";
import { PageWrapper } from "@/components/PageWrapper";
import ResultsPage from "@/components/ResultsPage";

const AgentResults = () => (
  <PageWrapper>
    <div className="m-0">
      <div className="main-content p-0 pb-4 agent-no-login-content">
        <div className="agent-dashboard-wrap">
          <ResultsPage />
        </div>
      </div>
    </div>
  </PageWrapper>
);

export default AgentResults;
